<template>
  <div style="width: 100%">
    <v-row align="center" style="max-height: 56px">
      <div class="title text--secondary mt-2 px-4 text-uppercase">
        {{ $t("mentorship.allActive") }}
      </div>
      <div>
        <back-button />
      </div>
    </v-row>
    <v-row>
      <v-col class="d-flex">
        <v-autocomplete
          class="flex-grow-0 flex-shrink-1 mb-3"
          style="min-width: 325px;"
          v-model="filters"
          :placeholder="$t('mentorship.search')"
          :items="filteredTags"
          required
          chips
          deletable-chips
          solo
          hide-details
          :item-text="getDetailedTagText"
          multiple
          return-object
        >
          <template v-slot:item="{ item, attrs }">
            <v-list-item-action>
              <v-checkbox :input-value="attrs.inputValue"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="d-flex align-center">
                <span>{{ getDetailedTagText(item) }}</span>
                <v-chip small class="ml-3">
                  {{ item.mentorshipCount }}
                </v-chip>
              </v-list-item-title>
              <v-list-item-subtitle v-if="item.explanation">
                <span>{{ item.explanation }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <employee-mentorship
      v-if="filters.length"
      :loading="$apollo.loading"
      :id="me.id"
      :mentorships="ongoingMentorships"
      :mentorView="true"
      :showMentorColumn="true"
      @refresh="
        () => {
          $apollo.queries.ongoingMentorships.refresh();
          $apollo.queries.ongoingMentorshipTagIDs.refresh();
        }
      "
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getDetailedTagText } from "@/utils/tag";

import EmployeeMentorship from "@/components/EmployeeMentorship";
import BackButton from "@/components/control/BackButton";

import OngoingMentorshipsQuery from "@/graphql/queries/mentorship/OngoingMentorships.gql";
import OngoingMentorshipsTagIDsQuery from "@/graphql/queries/mentorship/OngoingMentorshipTagIDs.gql";
import TagsQuery from "@/graphql/Tags.gql";

export default {
  data() {
    return {
      filters: [],
    };
  },
  components: {
    BackButton,
    EmployeeMentorship,
  },
  computed: {
    ...mapState(["me"]),
    filteredTags() {
      if (!this.tags || !this.ongoingMentorshipTagIDs) {
        return [];
      }
      const counts = {};
      this.ongoingMentorshipTagIDs.forEach((tagId) => {
        counts[tagId] = (counts[tagId] || 0) + 1;
      });
      return this.tags
        .filter((tag) => counts[tag.id])
        .map((tag) => ({
          ...tag,
          mentorshipCount: counts[tag.id],
        }))
        .sort((a, b) => b.mentorshipCount - a.mentorshipCount);
    },
  },
  methods: {
    getDetailedTagText: getDetailedTagText,
  },
  apollo: {
    ongoingMentorships: {
      query: OngoingMentorshipsQuery,
      variables() {
        return {
          tagIds: this.filters.map((f) => f.id),
        };
      },
    },
    tags: {
      query: TagsQuery,
    },
    ongoingMentorshipTagIDs: {
      query: OngoingMentorshipsTagIDsQuery,
    },
  },
};
</script>
